import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "grid justify-content-center ml-0" }
const _hoisted_2 = {
  key: 0,
  div: ""
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "grid col-12 justify-content-center" }
const _hoisted_5 = {
  class: "col-12",
  style: {"display":"flex","justify-content":"end"}
}
const _hoisted_6 = { class: "col-12 mt-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "grid mr-0 justify-content-center",
  ref: "paymentModal"
}
const _hoisted_17 = { class: "col-12 xl:col-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationCard = _resolveComponent("NotificationCard")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PaymentCard = _resolveComponent("PaymentCard")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Footer = _resolveComponent("Footer")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NotificationCard),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Card, { class: "col-11 mb-5 mt-3" }, {
        content: _withCtx(() => [
          (_ctx.isLoadingTickets)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_LoadingSpinner, { loading: _ctx.isLoadingTickets }, null, 8, ["loading"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_Button, {
                      class: "split-sales-order-btn",
                      label: "Print/Export",
                      icon: "pi pi-print",
                      onClick: _ctx.printTable
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_DataTable, {
                      class: "p-datatable-sm",
                      value: _ctx.pagedInvoices,
                      dataKey: "ar_id",
                      paginator: "",
                      lazy: "",
                      first: _ctx.first,
                      "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.first) = $event)),
                      rows: _ctx.rows,
                      totalRecords: _ctx.totalRecords,
                      customSort: true,
                      "onUpdate:rows": _ctx.onRowsPerPageChange,
                      onSort: _ctx.sortInvoices,
                      sortField: _ctx.sort.sortBy,
                      sortOrder: _ctx.sort.sortOrder,
                      onPage: _ctx.onPage,
                      filterDisplay: "menu",
                      filters: _ctx.filters,
                      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      rowsPerPageOptions: [25, 50, 75],
                      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} Invoices",
                      responsiveLayout: "stack",
                      breakpoint: "986px",
                      loading: _ctx.getLoadingStatus
                    }, {
                      empty: _withCtx(() => [
                        _createTextVNode(" No Invoices to display ")
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (col) => {
                          return (_openBlock(), _createBlock(_component_Column, {
                            key: col.key,
                            field: col.field,
                            header: col.header,
                            sortable: col.sortable || false,
                            showFilterMatchModes: col.filterType !== 'none' ? false : undefined,
                            showFilterOperator: col.filterType !== 'none' ? false : undefined,
                            bodyClass: col.bodyClass,
                            bodyStyle: col.bodyStyle
                          }, _createSlots({
                            body: _withCtx(({ data }) => [
                              (col.bodyType === 'link')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.isInvoiceLinkDisabled())
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(data.ar_id), 1))
                                      : (_openBlock(), _createBlock(_component_Button, {
                                          key: 1,
                                          class: "p-button-info p-button-text p-1 pr-0",
                                          onClick: ($event: any) => (_ctx.fetchInvoiceRecord(data.ar_id))
                                        }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("i", {
                                              class: _normalizeClass(_ctx.invoiceIcon(data.ar_id))
                                            }, null, 2), [
                                              [
                                                _directive_tooltip,
                                                'Generate Invoice ' + data.ar_id,
                                                void 0,
                                                { left: true }
                                              ]
                                            ]),
                                            _createTextVNode("   " + _toDisplayString(data.ar_id), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                  ], 64))
                                : (col.bodyType === 'status')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (data.ach === 'Y')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createVNode(_component_Badge, {
                                              value: "PAYMENT PENDING",
                                              severity: "info"
                                            })
                                          ]))
                                        : (data.status === 'O')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                              _createVNode(_component_Badge, {
                                                value: "OUTSTANDING",
                                                severity: "danger"
                                              })
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                              _createVNode(_component_Badge, {
                                                value: "PAID",
                                                severity: "success"
                                              })
                                            ]))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatBodyValue(col, data)), 1)
                                    ], 64))
                            ]),
                            _: 2
                          }, [
                            (col.filterType !== 'none')
                              ? {
                                  name: "filter",
                                  fn: _withCtx(() => [
                                    (col.filterType === 'text')
                                      ? (_openBlock(), _createBlock(_component_InputText, {
                                          key: 0,
                                          type: "text",
                                          modelValue: _ctx.getFilterValue(col),
                                          "onUpdate:modelValue": ($event: any) => (_ctx.setFilterValue(col, $event)),
                                          class: "p-column-filter",
                                          placeholder: col.filterPlaceholder
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                                      : (col.filterType === 'calendar')
                                        ? (_openBlock(), _createBlock(_component_Calendar, {
                                            key: 1,
                                            modelValue: _ctx.getFilterValue(col),
                                            "onUpdate:modelValue": ($event: any) => (_ctx.setFilterValue(col, $event)),
                                            selectionMode: "range",
                                            manualInput: false,
                                            placeholder: col.filterPlaceholder,
                                            showButtonBar: true,
                                            showIcon: true
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                                        : (col.filterType === 'dropdown')
                                          ? (_openBlock(), _createBlock(_component_Dropdown, {
                                              key: 2,
                                              modelValue: _ctx.getFilterValue(col),
                                              "onUpdate:modelValue": ($event: any) => (_ctx.setFilterValue(col, $event)),
                                              options: _ctx.getFilterOptions(col),
                                              optionLabel: "name",
                                              optionValue: "code",
                                              placeholder: col.filterPlaceholder,
                                              style: { width: '150px' }
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"]))
                                          : _createCommentVNode("", true)
                                  ]),
                                  key: "0"
                                }
                              : undefined,
                            (col.filterType !== 'none')
                              ? {
                                  name: "filterclear",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_Button, {
                                      type: "button",
                                      label: "Clear",
                                      onClick: ($event: any) => (_ctx.clearColumnFilter(col))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  key: "1"
                                }
                              : undefined,
                            (col.filterType !== 'none')
                              ? {
                                  name: "filterapply",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_Button, {
                                      type: "button",
                                      label: col.filterApplyLabel || 'Apply',
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fetchFilteredInvoices(false)))
                                    }, null, 8, ["label"])
                                  ]),
                                  key: "2"
                                }
                              : undefined
                          ]), 1032, ["field", "header", "sortable", "showFilterMatchModes", "showFilterOperator", "bodyClass", "bodyStyle"]))
                        }), 128)),
                        _createVNode(_component_Column, null, {
                          body: _withCtx(({data}) => [
                            (data.status === 'O')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (!_ctx.inPayArray(data.ar_id))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        (data.ach_pending !== 'Y')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                              _createVNode(_component_Button, {
                                                label: "Click to Pay",
                                                class: "p-button-rounded text-md p-1",
                                                style: {"width":"105px"},
                                                onClick: ($event: any) => (_ctx.addInvoice(data))
                                              }, null, 8, ["onClick"])
                                            ]))
                                          : (data.ach_pending === 'Y')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        (!_ctx.hover[data.ar_id])
                                          ? (_openBlock(), _createBlock(_component_Button, {
                                              key: 0,
                                              value: { arId: data.ar_id, balance: data.balance },
                                              onClick: _ctx.addInvoice,
                                              icon: "pi pi-check",
                                              iconPos: "right",
                                              class: "p-button-rounded p-button-success text-md p-1",
                                              style: {"width":"105px"},
                                              label: "Selected",
                                              onMouseover: ($event: any) => (_ctx.hover[data.ar_id] = true)
                                            }, null, 8, ["value", "onClick", "onMouseover"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.hover[data.ar_id])
                                          ? (_openBlock(), _createBlock(_component_Button, {
                                              key: 1,
                                              value: { arId: data.ar_id, balance: data.balance },
                                              onClick: ($event: any) => (_ctx.removeInvoice(data)),
                                              icon: "pi pi-times",
                                              iconPos: "right",
                                              class: "p-button-rounded p-button-danger text-md p-1",
                                              style: {"width":"105px"},
                                              label: "Remove",
                                              onMouseleave: ($event: any) => (_ctx.hover[data.ar_id] = false)
                                            }, null, 8, ["value", "onClick", "onMouseleave"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "first", "rows", "totalRecords", "onUpdate:rows", "onSort", "sortField", "sortOrder", "onPage", "filters", "loading"])
                  ])
                ]),
                (_ctx.invoice.invoicesToPay.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_PaymentCard, {
                          status: this.selectedStatus,
                          custId: this.customerId(),
                          onPaymentCompleted: _ctx.onPaymentCompleted
                        }, null, 8, ["status", "custId", "onPaymentCompleted"])
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Footer)
  ], 64))
}